import { store } from "@store/store";
import { updatePropsAction } from "../updateProps";
import { checkoutApiCall } from "../checkoutApiCall";

export const RedirectToDefaultPaymentOrAutopay = async (args: any) => {
  const { modal_id, redirect_data } = args || {};
  const state = store?.getState();
  const config = state?.configuration?.normalisedConfig;
  const showAutopayModal = config?.autopay_modal?.props?.show_autopay_modal;
  if (showAutopayModal) {
      updatePropsAction({
        component_id: modal_id,
        update_props: { is_visible: true }
      })
  } else {
    const { proposal_ekey } = require("next/router").default.query;
    if (proposal_ekey) {
      await checkoutApiCall({ proposal_ekey, data: redirect_data });
    }
  }
};

export default RedirectToDefaultPaymentOrAutopay;